module.exports = __webpack_public_path__ + "img/header-menu-icon13-img.164d4927.png";